import { IFinYearRequisitionLineItem } from "./RequisitionConversionToBidDetail";

export class RequisitionSubItemSelectionGridDetail {
	requisitionId: number = 0;
	requisitionLineId: number = 0;
	programme: string = "";
	department: string = "";
	item: string = "";
	convertableQty: number = 0;
	convertedQty: number = 0;
	estUnitCost: number = 0;
	subTotal: number = 0;
	vat: number = 0;
	insuranceAmount: number = 0;
	totalEstAmount: number = 0;
	isChecked: boolean = false;
	bidLineId: number = 0;
	itemAvailability: string = "";
	procurementMethodId: number | null = 0;
	isTransversalContract: boolean = false;
	itemAvailabilityId: number = -1;
	lineItemDetailList: IFinYearRequisitionLineItem[] = [];
}

export class RequisitionProcurementMethodGridDetail {
	isChecked: boolean = false;
	itemAvailability: string = "";
	procurementMethod: string = "";
	procurementMethodDescription: string = "";
	procurementMethodId: number | null = 0;
	items: RequisitionSubItemSelectionGridDetail[] = [];
}

export class RequisitionItemSelectionGridDetail {
	requisitionId: number = 0;
	requisitionNumber: string = "";
	items: RequisitionProcurementMethodGridDetail[] = [];
}
